import _toFinite from 'lodash/toFinite';
import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_GET_CARPARK_PLANNINGS,
  CPM_GET_CARPARK_PLANNING,
  CPM_ADD_CARPARK_PLANNING,
  CPM_UPDATE_CARPARK_PLANNING,
  CPM_DELETE_CARPARK_PLANNING,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../../models/cpm/planning';
import { deserialize as deserializeOperation } from '../../../models/cpm/synchronization';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmCarparkPlanning;
const cpmCarparkPlanning = (state = initialSettings, action) => {
  let key;
  let mutationResult;
  // let wsPayload;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullCarpark' || action.target === 'currentCarpark') {
        return {
          ...state,
          list: { ...initialSettings.list },
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'addCarparkPlanning':
          key = 'add';
          break;
        case 'updateCarparkPlanning':
          key = 'update';
          break;
        case 'deleteCarparkPlanning':
          key = 'delete';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST
    case CPM_GET_CARPARK_PLANNINGS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: null,
          error: null,
          loading: true,
        },
      };
    case `${CPM_GET_CARPARK_PLANNINGS}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_PLANNINGS}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserialize(action.data.listPlannings),
          loading: false,
        },
      };
    // GET
    case CPM_GET_CARPARK_PLANNING:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case `${CPM_GET_CARPARK_PLANNING}_ERROR`:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_GET_CARPARK_PLANNING}_SUCCESS`:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.getPlanning),
        },
      };
    // ADD
    case CPM_ADD_CARPARK_PLANNING:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_ADD_CARPARK_PLANNING}_ERROR`:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case `${CPM_ADD_CARPARK_PLANNING}_SUCCESS`:
      mutationResult = action.data.addPlanning;
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
            operation: deserializeOperation(mutationResult.operation),
          },
        },
      };
    // UPDATE
    case CPM_UPDATE_CARPARK_PLANNING:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_UPDATE_CARPARK_PLANNING}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_CARPARK_PLANNING}_SUCCESS`:
      mutationResult = action.data.updatePlanning;
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
            operation: deserializeOperation(mutationResult.operation),
          },
        },
      };
    // DELETE
    case CPM_DELETE_CARPARK_PLANNING:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_DELETE_CARPARK_PLANNING}_ERROR`:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case `${CPM_DELETE_CARPARK_PLANNING}_SUCCESS`:
      mutationResult = action.data.deletePlanning;
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
            operation: deserializeOperation(mutationResult.operation),
          },
        },
      };
    default:
      return state;
  }
};

export default cpmCarparkPlanning;



// WEBPACK FOOTER //
// ./reducers/cpm/carpark/carparkPlanning.js